// ReactJS
import * as React from 'react';

// Material UI
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { IconButton } from '@mui/material';

// Others NPM's
import { ReactPdfDocument } from './ReactPdfDocument';
import { pdf, PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';

// Icons Material UI
import CloseIcon from '@mui/icons-material/Close';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "75vw",
    height: "90vh",
    minHeight: "90vh",
    maxHeight: "90vh",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    overflowY: 'auto',
};

export default function ModalPDF(params) {
    React.useEffect(() => {
        const generateBlob = async () => {
            try {
                const result = await pdf(<ReactPdfDocument data={params.base} />).toBlob();
            } catch (error) {
                console.error("Error generando el blob:", error);
            }
        };
        generateBlob();
    }, []);

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true)
    };
    const handleClose = () => setOpen(false);
    // const childWithProps = React.cloneElement(params.children, { onPDFAction: handleOpen });


    return (
        <div>
            {params.children && React.cloneElement(params.children, { onClick: handleOpen })}
            {!params.children && <Button variant='contained' color='ochre' onClick={handleOpen}>Ver PDF</Button>}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className='modalPDFGeneral'
            >

                <Box sx={style}>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        color='ochre'
                        sx={(theme) => ({
                            position: 'absolute',
                            right: 40,
                            top: 3,
                            color: "ochre",
                            backgroundColor: "white"
                        })}
                    >
                        <CloseIcon />
                    </IconButton>
                    {open && (
                        <PDFDownloadLink
                            className='modalPDFViewA'
                            document={<ReactPdfDocument base={params.base} tipo={params.tipo} />}
                            fileName={params.base.datosCliente.cotizacion + "_" + params.base.datosCliente.nombre + ".pdf"}
                        >
                            {({ blob, url, loading, error }) =>
                                loading ? 'Cargando documento...' : 'Descargar'
                            }
                        </PDFDownloadLink>
                    )}
                    {open && (
                        <PDFViewer
                            className='PDFRender'
                            width={'100%'}
                            style={{ height: 'calc(100%)' }}
                        >
                            <ReactPdfDocument base={params.base} tipo={params.tipo} />
                        </PDFViewer>
                    )}
                </Box>
            </Modal>
        </div>
    );
}
